// Utility to handle modal body style cleanup
export const cleanupModalBodyStyles = () => {
  // Remove pointer-events none from body
  document.body.style.removeProperty('pointer-events');
  
  // Remove overflow hidden that might be set by modal
  document.body.style.removeProperty('overflow');
  
  // Clean up any other modal-related styles
  document.body.style.removeProperty('padding-right');
  
  // Remove any modal backdrop classes that might remain
  document.body.classList.remove('modal-open');
};

// Hook to handle modal cleanup on unmount
export const useModalCleanup = () => {
  const cleanupOnClose = <T extends (...args: any[]) => void>(onClose?: T) => {
    return (...args: Parameters<T>) => {
      // Call the original onClose function with all its parameters
      if (onClose) {
        onClose(...args);
      }
      
      // Small delay to ensure modal is fully closed before cleanup
      setTimeout(() => {
        cleanupModalBodyStyles();
      }, 100);
    };
  };

  return { cleanupOnClose };
}; 